import * as ServerComms from '../utilities/ServerComms';
import NormalBtn from '../StockItems/NormalBtn';
import Coin_MyCoin from './Coin.json';
import React from 'react';
import { parseUnits } from 'viem'
import {useState} from 'react';
import { useWriteContract } from 'wagmi'
import { usePublicClient } from 'wagmi';

function App({ address, amount, nosDec, coinName, chainId, chains, sessionID, userID, signKey, account, postPostFunction  }) {

  const [packageSelectedChainId, setPackageSelectedChainId] = useState(0);
  const [packageSelectedCoinAddress, setPackageSelectedCoinAddress] = useState("");
  const [packageSelectedSelectionState, setPackageSelectedSelectionState] = useState(0);

  const { writeContract } = useWriteContract();

  function failFunction(e){
    console.log(e);
    setPackageSelectedChainId(0);
    setPackageSelectedCoinAddress('');
    setPackageSelectedSelectionState(0);
  }

  function postPostFunctionR(x:any){
    console.log(x);
    failFunction();
    postPostFunction(x);
  }

  const publicClient = usePublicClient();
  var pp = parseUnits(amount + '', nosDec);

  function onSuccess(data){
    var transferAmt = amount.toString();
    for (var i = 0; i < nosDec; i++){
      transferAmt += '0';
    }
    setPackageSelectedSelectionState(2);

     publicClient
    .getBlock() // https://viem.sh/docs/actions/public/getBlock.html
    .then(blockNumber => {
        var xx = {u:'recordTransaction', tHash:data, startingBlockNos:Number(blockNumber.number) - 10, account, transferAmt, chainId, coinAddress:address, coinName, sessionID, signKey, userID}
        console.log(xx);
         ServerComms.fetchSomething(xx, postPostFunctionR, failFunction);

    })
    .catch(error => console.log(error))
  }

  function onError(a){
    window.alert(a);
    console.log(a);
    failFunction();
  }

  const doWrite = (e: React.SyntheticEvent<EventTarget>) =>   {
    setPackageSelectedSelectionState(1);
    setPackageSelectedChainId(chainId);
    setPackageSelectedCoinAddress(address);

    writeContract({ 
          abi:Coin_MyCoin.abi,
          address,
          functionName: 'transfer',
          args: ['0x04CbF2f31BAFe46cbE919C9E71b02622E9A4115b', pp],
       }, {onSuccess, onError});

  }

  if (packageSelectedChainId === chainId && packageSelectedCoinAddress === address){
    if (packageSelectedSelectionState === 1){
      return <div>Check your wallet</div>
    }else if (packageSelectedSelectionState === 2){
      return <div>Verifying transaction. Please wait...</div>
    }
  }else{
    return <NormalBtn onClick={doWrite} title='Transfer'/>
  }
  return <div>H1</div>
}

export default App;

